import { useUiText } from "../../locale/UiLocale";
import { downloadText } from "../../download";
import { IconButton } from "../IconButton/IconButton";
import { buildCsv, CSV_MIME_TYPE, csvFileName } from "./csv";
import type { Column } from "./DataTableTypes";

interface ExportCsvButtonProps<R> {
  /** File name prefix; the export date is appended. */
  fileName: string;
  columns: Column<R>[];
  /** The rows to export, as filtered and sorted on screen. */
  rows: R[];
  disabled: boolean;
}

/** Downloads the given rows as a CSV file. */
export function ExportCsvButton<R>({ fileName, columns, rows, disabled }: ExportCsvButtonProps<R>): React.JSX.Element {
  const t = useUiText();
  function exportCsv(): void {
    downloadText(csvFileName(fileName, new Date()), buildCsv(columns, rows), CSV_MIME_TYPE);
  }

  return <IconButton label={t("Export CSV")} icon="download" onClick={exportCsv} disabled={disabled} />;
}
